import { render, staticRenderFns } from "./DescriptionContainer.vue?vue&type=template&id=c131e2a2&"
import script from "./DescriptionContainer.vue?vue&type=script&lang=js&"
export * from "./DescriptionContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports